export default __webpack_public_path__ + "static/enable-session-replay-in-project-settings-dark-mode-436e3f1e0dab2c17a5a969497db60cf0.png";